/**
 * @see \App\Domain\Tender\Policies\TenderStatusPolicy
 */
export default {
    'read-tender-status-list': (user) => {
        return user.hasAccess(["tender-status-all-admin", "tender-status-all-read"]);
    }
};
